// import * as roles from '../utils/rolesTypes'

const getters = {
}

export default getters
